import React, { lazy, Suspense } from 'react';

const LazyFaceIdDetail = lazy(() => import('./FaceIdDetail'));

const FaceIdDetail = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyFaceIdDetail {...props} />
  </Suspense>
);

export default FaceIdDetail;
